module.exports = __webpack_public_path__ + "99dd386a6aed689cba8c725571f40d98.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/banjo.png
// module id = 1803
// module chunks = 0